import { Navigation } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
  buildNavigateUrl,
  hasDestination,
  type MapsDestination,
} from '@/lib/maps';

interface NavigateButtonProps {
  destination: MapsDestination;
  /** Accent for the launch button (matches the stop kind). */
  accent?: 'pickup' | 'delivery' | 'primary';
}

const variantClasses = {
  primary: 'btn-primary',
  pickup: 'btn-pickup',
  delivery: 'btn-delivery',
} as const;

/**
 * Opens maps in a **new tab** (or the native Maps app on iPhone) via a real
 * anchor — never navigates the current Safari/PWA window away from the app.
 */
export function NavigateButton({ destination, accent = 'primary' }: NavigateButtonProps) {
  if (!hasDestination(destination)) return null;

  const url = buildNavigateUrl(destination);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        variantClasses[accent],
        'min-h-touch-large text-lg w-full inline-flex items-center justify-center gap-2',
      )}
    >
      <Navigation className="h-5 w-5" aria-hidden />
      Navigate
    </a>
  );
}
